import * as Sentry from "@sentry/react";
import { getDefaultSentryConfig } from "shared/sentry/initConfig";

Sentry.init({
    integrations: [
        new Sentry.BrowserTracing({
            tracePropagationTargets: []
        }),
        new Sentry.Replay({
            maskAllInputs: false,
            maskAllText: false,
        })],
    ...getDefaultSentryConfig({
        dsn: site.deploymentValues.sentryDsn,
        buildVersion: site.deploymentValues.build,
        environment: site.deploymentValues.sentryEnvironment,
        enabled: process.env.NODE_ENV === "production" && window.location.pathname !== "/webform.aspx",
    }),
    // Use the tunnel if we're not on MainWebUI
    tunnel: document.querySelector(`meta[name="isPageServer"]`)?.getAttribute("value") === "true" ? "/tunnel" : undefined,
});

if (site?.currentUser != null) {
    Sentry.setUser({
        id: site.currentUser.userId.toString(),
        username: site.currentUser.fullName
    });
}
